<c-card *transloco="let t">
  <c-card-body class="px-2">

    <app-worker-reports-menu></app-worker-reports-menu>

      <c-container class="px-2">
          <c-row>
            <c-col sm="6">
                <h1>{{ t('Timesheets') }}</h1>
            </c-col>
            <c-col  sm="6" class="text-end">

              <c-row class="justify-content-end">


                <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
                  <c-input-group  class="text-end">
                    <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                    <select aria-label="Default select example" name="page" cSelect (change)="getTimesheets()"  [(ngModel)]="pagination.page">
                      <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                    </select>
                  </c-input-group>
                </c-col>
                <c-col xs="auto">
                  <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
                    <i class="fa-solid fa-file-excel"></i> {{ t('Export Timesheets') }}
                  </button>
                </c-col>

              </c-row>

            </c-col>
          </c-row>

          <c-card class="mb-2">
            <c-card-body>
              <form cForm class="row row-cols-lg-auto g-3 align-items-center" (ngSubmit)="getTimesheets()">
                <c-col xs="auto">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                    <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>

                  </c-input-group>

                </c-col>

                <c-col xs="auto">
                  <ng-select
                  [items]="okService.workers"
                  [(ngModel)]="worker_id"
                  bindLabel="name"
                  bindValue="id"
                  name="worker_id"
                  placeholder="{{ t('Worker') }}"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="auto" *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                  <ng-select
                  [items]="okService.groups"
                  [(ngModel)]="group"
                  bindLabel="name"
                  bindValue="id"
                  name="group"
                  placeholder="{{ t('Worker Group') }}"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="1">
                  <button cButton type="submit">{{ t('Update') }}</button>
                </c-col>

                </form>

              </c-card-body>
          </c-card>

          <c-row *ngIf="timesheets">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ t('Name') }}</th>
                    <th scope="col">{{ t('Start') }}</th>
                    <th scope="col">{{ t('End') }}</th>
                    <th scope="col">{{ t('Hours') }}</th>
                    <th scope="col">{{ t('Total Time') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let timesheet of timesheets">
                      <th scope="row">
                        <div>
                          <span>{{timesheet.name}}</span>
                        </div>
                      </th>
                      <td>
                        <span>{{timesheet.start}}</span>
                      </td>
                      <td>
                        {{timesheet.end}}
                      </td>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{timesheet.hours}}</span>
                        </div>
                      </th>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{timesheet.total_time}}</span>
                        </div>
                      </th>

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

        </c-container>

  </c-card-body>
</c-card>
